(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/helpers.js');

'use strict';

const logger = svs.core.log.getLogger('marketplace-competition:overview-hero');
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  resolveCompetitionUrl
} = svs.components.marketplaceCompetition.helpers;

const capitalize = string => {
  try {
    return string[0].toUpperCase() + string.slice(1);
  } catch (err) {
    logger.log('capitalize error: ', err);
    return string;
  }
};

const ordinalNumber = n => "".concat(n).concat(n < 3 ? ':a' : ':e');

const getOngoingBetPath = (competition, wagerSerial) => {
  const navigationPath = "/".concat(TipsenModuleGameUrl.MY_BETS);
  const compUrl = resolveCompetitionUrl(competition.compType);
  if (wagerSerial) {
    return "".concat(navigationPath, "/").concat(wagerSerial, "/").concat(compUrl);
  }
  return navigationPath;
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.helpers', {
  capitalize,
  getOngoingBetPath,
  ordinalNumber
});

 })(window);